import { logger } from '../repositories/HomeRepository'

/**
 * Given a page name, returns a logging function that takes a message and logs
 * both the page and message to the server.
 * @param {string} page The name of the page where the error is generated.
 */
export const logErrorOnServer = page => message => {
    logger({
        page,
        message,
    })
}
